import React from 'react';
import createSVG from './createSVG';

const CloseIcon = ({style}) => (
  <path style={style} strokeWidth=".87" d="M12.643 3.09L3 12.73m0-9.64l9.643 9.642" stroke="#7D7D7D" fill="none" fillRule="evenodd"/>
);

export default createSVG(CloseIcon);
